import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export default function AnalyticsFiltersBar({
  showCourse = true,
  showAcademicCourse = true,
  showPlan = true,
  showLocation = false,
  showDueStatus = false,
  showAlertLevel = false,
  showSchoolType = false,
  showSchoolGender = false,
  showMode = false,
  showEngagementLevel = false,
  courses = [],
  academicCourses = [],
  plans = [],
  locations = [],
  courseId,
  setCourseId,
  academicCourseId,
  setAcademicCourseId,
  planId,
  setPlanId,
  location,
  setLocation,
  dueStatus,
  setDueStatus,
  alertLevel,
  setAlertLevel,
  schoolType,
  setSchoolType,
  schoolGender,
  setSchoolGender,
  mode,
  setMode,
  engagementLevel,
  setEngagementLevel,
}) {
  return (
    <Grid container spacing={2}>
      {showCourse && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Course</InputLabel>
            <Select
              label="Course"
              value={courseId || ""}
              onChange={(e) => {
                setCourseId?.(e.target.value || "");
                setAcademicCourseId?.("");
                setPlanId?.("");
              }}
            >
              <MenuItem value="">All courses</MenuItem>
              {courses.map((c) => (
                <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      {showAcademicCourse && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small" disabled={!courseId}>
            <InputLabel>Year / Academic course</InputLabel>
            <Select
              label="Year / Academic course"
              value={academicCourseId || ""}
              onChange={(e) => {
                setAcademicCourseId?.(e.target.value || "");
                setPlanId?.("");
              }}
            >
              <MenuItem value="">All</MenuItem>
              {academicCourses.map((ac) => (
                <MenuItem key={ac.id} value={ac.id}>
                  {ac.name}{ac.school_year ? ` (${ac.school_year})` : ""}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      {showPlan && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small" disabled={showAcademicCourse ? !academicCourseId : !courseId}>
            <InputLabel>Group</InputLabel>
            <Select
              label="Group"
              value={planId || ""}
              onChange={(e) => setPlanId?.(e.target.value || "")}
            >
              <MenuItem value="">All groups</MenuItem>
              {plans.map((p) => (
                <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      {showLocation && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Location</InputLabel>
            <Select label="Location" value={location || ""} onChange={(e) => setLocation?.(e.target.value || "")}>
              <MenuItem value="">All locations</MenuItem>
              {locations.map((loc) => (
                <MenuItem key={loc} value={loc}>{loc}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      {showDueStatus && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Due status</InputLabel>
            <Select label="Due status" value={dueStatus || "overdue"} onChange={(e) => setDueStatus?.(e.target.value)}>
              <MenuItem value="overdue">Overdue</MenuItem>
              <MenuItem value="due_soon">Due within 7 days</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
      {showAlertLevel && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Alert level</InputLabel>
            <Select label="Alert level" value={alertLevel || ""} onChange={(e) => setAlertLevel?.(e.target.value || "")}>
              <MenuItem value="">All</MenuItem>
              <MenuItem value="high">High</MenuItem>
              <MenuItem value="medium">Medium</MenuItem>
              <MenuItem value="low">Low</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
      {showSchoolType && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>School type</InputLabel>
            <Select label="School type" value={schoolType || ""} onChange={(e) => setSchoolType?.(e.target.value || "")}>
              <MenuItem value="">All</MenuItem>
              <MenuItem value="grammar">Grammar</MenuItem>
              <MenuItem value="independent">Independent</MenuItem>
              <MenuItem value="state">State</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
      {showSchoolGender && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Intake</InputLabel>
            {/* Values are schools.gender's own (App\Models\School::GENDERS), not display labels. */}
            <Select label="Intake" value={schoolGender || ""} onChange={(e) => setSchoolGender?.(e.target.value || "")}>
              <MenuItem value="">All intakes</MenuItem>
              <MenuItem value="boys">Boys only</MenuItem>
              <MenuItem value="girls">Girls only</MenuItem>
              <MenuItem value="co-ed">Mixed (co-ed)</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
      {showMode && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Mode</InputLabel>
            <Select label="Mode" value={mode || ""} onChange={(e) => setMode?.(e.target.value || "")}>
              <MenuItem value="">All modes</MenuItem>
              <MenuItem value="online">Online</MenuItem>
              <MenuItem value="in_person">In Person</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
      {showEngagementLevel && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Engagement level</InputLabel>
            <Select label="Engagement level" value={engagementLevel || ""} onChange={(e) => setEngagementLevel?.(e.target.value || "")}>
              <MenuItem value="">All levels</MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="weak">Weak</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
    </Grid>
  );
}
